<template>
  <div class="ad-media-audit-cell">
    <span>{{ row.ad_media_audit || '--' }}</span>
    <template v-if="row.ad_media_audit === '违规'">
      <el-popover
        v-if="auditDetail && auditDetail.auditResults && auditDetail.auditResults.length"
        placement="top"
        trigger="hover"
        width="800"
      >
        <el-table
          :data="auditDetail.auditResults"
          size="mini"
          border
        >
          <el-table-column
            prop="tag"
            label="标签"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="reason"
            label="违规原因"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="suggestion"
            label="修改建议"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="confidence"
            label="置信度"
            width="80"
          ></el-table-column>
        </el-table>
        <i
          slot="reference"
          class="el-icon-warning"
          style="color: #e6a23c; margin-left: 5px; cursor: pointer"
        ></i>
      </el-popover>
      <i
        v-else-if="loading"
        class="el-icon-loading"
        style="margin-left: 5px"
      ></i>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AdMediaAuditCell',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    auditDetail() {
      return this.row._auditDetail || null;
    },
    loading() {
      return this.row._auditDetailLoading || false;
    },
  },
};
</script>

<style scoped>
.ad-media-audit-cell {
  display: inline-flex;
  align-items: center;
}
</style>
